import { useEffect, useState } from 'react';
import { TERMS_AND_CONDITIONS_VERSION } from '../../config/environment';
import { GetWeb, PostWeb } from '../../store/api//authorizedRequest';
import CircularProgress from '@mui/material/CircularProgress';
import Dialog from '@mui/material/Dialog';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import Button from '@mui/material/Button';
import CheckBox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import Typography from '@mui/material/Link';
import { TERMSANDCONDITIONS } from '../../theme/constants';

const getTermsAndConditionsRequest = async () => {
  const request = await GetWeb(
    `/identification/termsandconditions?termsAndConditionsVersion=${TERMS_AND_CONDITIONS_VERSION}`
  );
  return request;
};

const setTermsAndConditionsRequest = async (nxtEntityId) => {
  const body = {
    termsAndConditionsVersion: TERMS_AND_CONDITIONS_VERSION,
    nxtEntityId: nxtEntityId,
  };
  const request = await PostWeb('/identification/termsandconditions/set', body);
  return request;
};

const TermsAndConditions = (props) => {
  const nxtEntityId = props.userProfile.nxtEntityId;
  const [checkedTermsAndConditions] = useState(false);
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(true);
  const [checkboxValue, setCheckboxValue] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    const fetchTermsAndConditions = async () => {
      try {
        const request = await getTermsAndConditionsRequest();
        const response = await fetch(request);
        const result = await response.json();

        if (result === true) {
          setOpen(false);
        } else {
          setOpen(true);
          setLoading(false);
        }
      } catch (e) {
        setLoading(false);
        setIsError(true);
      }
    };

    fetchTermsAndConditions();
  }, []);

  const handleCheckBoxChange = (event) => {
    setCheckboxValue(event.target.checked);
  };

  const handleSaveAndClose = async (event, reason) => {
    if (reason && reason === 'backdropClick') return;
    setIsSaving(true);
    const request = await setTermsAndConditionsRequest(nxtEntityId);
    await fetch(request)
      .then((response) => response.json())
      .then((result) => {
        setIsSaving(false);
        if (result === true) {
          setOpen(false);
        } else {
          setIsError(true);
        }
      })
      .catch((e) => {
        setIsSaving(false);
        setIsError(true);
      });
  };

  return (
    <Dialog open={open}>
      {!isError && !loading && (
        <DialogTitle>{TERMSANDCONDITIONS.TERMS_CONDITIONS_TITLE}</DialogTitle>
      )}
      {isError && (
        <DialogTitle>
          <span style={{ color: 'red' }}>{TERMSANDCONDITIONS.NETWORK_ERROR}</span>
        </DialogTitle>
      )}
      <DialogContent>
        {isError && (
          <DialogContentText>
            <span style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <span style={{ marginBottom: '20px' }}>{TERMSANDCONDITIONS.NETWORK_MESSAGE}</span>
            </span>
          </DialogContentText>
        )}
        {!isError && (
          <DialogContentText>
            {loading && (
              <span style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <span>{TERMSANDCONDITIONS.CHECK_MESSAGE_WHILE_LOADING}</span>
                <span>
                  <CircularProgress size="20px" />
                </span>
              </span>
            )}
            {!loading && !checkedTermsAndConditions && (
              <span style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <span style={{ cursor: 'pointer' }}>
                  <Typography>
                    <a
                      style={{ textDecoration: 'underline' }}
                      href="https://documentation.nxtport.com/certified-pickup/certified-pick-up-cpu-terms-conditions"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {TERMSANDCONDITIONS.CLICK_HERE_TO_READ}
                    </a>
                  </Typography>
                </span>
                <span style={{ marginTop: '15px' }}>{TERMSANDCONDITIONS.BY_CHECKING_THIS_BOX}</span>
                <span style={{ marginTop: '15px' }}>
                  <FormControlLabel
                    control={
                      <CheckBox
                        name="checkBoxTAndC"
                        color="primary"
                        checked={checkboxValue}
                        onChange={handleCheckBoxChange}
                        disabled={isSaving}
                      />
                    }
                    label={TERMSANDCONDITIONS.I_ACCEPT_TC}
                  />
                </span>
              </span>
            )}
          </DialogContentText>
        )}
      </DialogContent>
      <DialogActions>
        {isSaving && (
          <div>
            <div style={{ float: 'left', marginRight: '12px' }}>
              <CircularProgress size="15px" />
            </div>
            <div style={{ float: 'right' }}>{TERMSANDCONDITIONS.PLEASE_WAIT}</div>
          </div>
        )}
        {!isError && !isSaving && !loading && checkboxValue && (
          <Button onClick={handleSaveAndClose} color="primary" autoFocus>
            {TERMSANDCONDITIONS.SAVE_AND_CLOSE}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default TermsAndConditions;
